
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/markets/[slug]",
      function () {
        return require("private-next-pages/markets/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/markets/[slug]"])
      });
    }
  